import { render } from "./video-module.vue?vue&type=template&id=67efcc7a"
import script from "./video-module.vue?vue&type=script&lang=js"
export * from "./video-module.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__